<template>
    <UiCard
        v-if="attention && attention.id"
        interactive
        class="flex items-center text-xs"
        @click="open"
    >
        <div class="grow-0 px-4 py-2 font-semibold">
            {{ attention.id }}
        </div>
        <div class="flex-auto py-2">
            <div v-if="attention.name">
                {{ attention.name }}
            </div>
            <div>{{ dateHumanReadable(attention.starts_at) }} - {{ dateHumanReadable(attention.ends_at) }}</div>
        </div>
        <div class="grow-0 px-4"></div>
    </UiCard>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { Attention } from '@src/Attention/Pages/types';
import { dateHumanReadable } from '@src/Common/Helpers/dates';
import { router } from '@inertiajs/vue3';

const props = defineProps<{
    attention: Attention;
}>();

const attention = toRef(props, 'attention');

const open = (): void => {
    router.visit(route('attention.admin.edit', { id: attention.value.id }));
};
</script>
